
















































































































































import {Vue, Component, Watch} from 'vue-property-decorator'
import dataProxy from "@/services/data-proxy.service";
import {mixins} from "vue-class-component"
import {ComponentBaseMixin} from "@/mixins/component-base.mixin";
import TableEditorsMixin from "@/mixins/table-editors.mixin";
import {
    Faktura, PodesavanjeSistema, RaspodelaTroska,
    StavkaDokumenta,
} from "@/services/BackendProxies";
import * as _ from 'lodash';
import {State} from "vuex-class";

@Component({})
export default class FakturaTroskovaVoznogParka extends mixins(ComponentBaseMixin, TableEditorsMixin) {
    faktura = Faktura.fromJS({datum: new Date(), troskovi: []});
    raspodelaTroskova = [];
    @State podesavanjeSistema: PodesavanjeSistema;

    raspodelaTroskaColumns = [];
    isBusy = false;
    dialogVisible = false;

    async created() {
        this.novaFaktura();
        this.raspodelaTroskaColumns = [
            {field: 'voziloId', title: this.$i18n.t('vozilo'), formatter: this.raspodelaTroskaVoziloFormatter},
            {field: 'kolicina', title: this.$i18n.t('kolicina'), width: 130, formatter: this.raspodelaTroskaKolicinaFormatter},
            {field: 'action', align: 'right', width: 30, formatter: `<i class="fa fa-trash text-danger"></i>`}
        ];

        this.$nextTick(() => (<any>this.$refs.observer).validate());
    }

    otvoriDialogRaspodeleTroska(row) {
        this.raspodelaTroskova = row.raspodelaTroskova;
        this.dialogVisible = true;
    }

    onVrsteOdrzavanja(vrstaOdrzavanja: number[], row: StavkaDokumenta) {
        row.vrstaOdrzavanjaId = vrstaOdrzavanja.length ? vrstaOdrzavanja[0] : null;
    }

    dodajStavkuFakture() {
        this.faktura.troskovi.push(StavkaDokumenta.fromJS({
            iznos: 0,
            rabat: 0,
            pdvStopa: this.podesavanjeSistema ? this.podesavanjeSistema.pdvStopa : 0,
            raspodelaTroskova: []
        }));
    }

    async raspodelaCellClick(field, value, row) {
        if (field === 'action') {
            const idx = this.raspodelaTroskova.indexOf(row);
            if (idx > -1) {
                this.raspodelaTroskova.splice(idx, 1);
            }
        }
    }

    raspodelaTroskaVoziloFormatter(value, row) {
        return this.vueFormatter({
            template: `<mf-vozila v-model="row.voziloId" parent="#dialog .modal-body"></mf-vozila>`,
            data: { row },
            store: this.$store
        })
    }

    raspodelaTroskaKolicinaFormatter(value, row) {
        return this.vueFormatter({
            template: `<input type="text" @keypress.enter="dodajRaspodelu" ref="dialogKolicina" style="text-align: right;"
                :class="{invalid: isNaN(row.kolicina) || row.kolicina < 1}" class="form-control" v-model.number.lazy="row.kolicina">`,
            data: { row },
            methods: {dodajRaspodelu: this.dodajRaspodelu}
        })
    }

    dodajRaspodelu() {
        this.raspodelaTroskova.push(new RaspodelaTroska())
    }

    async obrisiStavku(row) {
        const idx = this.faktura.troskovi.indexOf(row);
        if (idx > -1) {
            this.faktura.troskovi.splice(idx, 1);
        }
    }

    async sacuvajFakturu() {
        if (this.isBusy) return;
        const valid = (await (<any>this.$refs.observer).validate()) && this.validacijeStavki();
        if (valid) {
            this.isBusy = true;
            try {
                this.faktura = await this.saveData(() => dataProxy.sacuvajFakturu(this.faktura))();
            } finally {
                this.isBusy = false;
            }
        } else {
            this.showError('nisu sva obavezna polja popunjena');
        }
    }

    async zakljuciFakturu() {
        if (this.isBusy) return;

        try {
            this.isBusy = true;
            const valid = (await (<any>this.$refs.observer).validate()) && this.validacijeStavki();
            if (valid) {
                await this.saveData(() => dataProxy.zakljuciFakturu(this.faktura))();
                this.novaFaktura();
            }
        } finally {
          this.isBusy = false;
        }
     }

    validacijeStavki() {
         this.faktura.troskovi = this.faktura.troskovi.filter(x => x.vrstaTroskaId && x.cena && x.kolicina);
         this.faktura.troskovi.forEach(x => x.raspodelaTroskova = x.raspodelaTroskova.filter(r => r.voziloId && r.kolicina));

         // proveri slaganje kolicine
         const stavkaSaNeslaganjemKolicine = this.faktura.troskovi.find(x => x.raspodelaTroskova.length > 0 && _.sumBy(x.raspodelaTroskova, 'kolicina') != x.kolicina);
         if (stavkaSaNeslaganjemKolicine) {
             this.showError('kolicina na stavkama i na raspodeli se ne slazu');
             return false;
         }
         return true;
     }

    novaFaktura() {
        this.faktura = Faktura.fromJS({
            datum: new Date(),
            troskovi: []
        });
    }

    @Watch('faktura.voziloId') onVoziloChanged(id) {
       if (id) {
           this.faktura.troskovi.forEach(x => x.raspodelaTroskova = []);
       }
    }

    @Watch('faktura.troskovi', {deep: true}) onStavkeChange(stavka: StavkaDokumenta[]) {
        stavka.forEach(s => {
            s.osnovica = (s.kolicina || 0) * (s.cena || 0) * (1 - (s.rabat || 0) / 100);
            s.pdv = s.osnovica * s.pdvStopa / 100;
            s.iznos = s.osnovica + s.pdv;
        });
    }

    get ukupno() {
        return _.sumBy(this.faktura.troskovi, (s: StavkaDokumenta) => (s.kolicina || 0) * (s.cena || 0) * (1 - (s.rabat || 0) / 100));
    }

    get pdv() {
        return _.sumBy(this.faktura.troskovi, s => (s.osnovica || 0) * (s.pdvStopa || 0) / 100)
    }

    get ukupnoSaPdv() {
        return this.ukupno + this.pdv;
    }

    postBody() {
        this.vueFormatterPostBody();
        const input = $('input.invalid');
        if (input.length) {
            this.$nextTick(() => input[0].focus());
        }
    }

    fokusirajCeliju(dataCellValue) {
        this.$nextTick(() => {
            $(`[data-cell="${dataCellValue}"]`).focus();
        });
    }

    async onUnetBrojDokumenta(id) {
        this.faktura = await this.loadData(() => dataProxy.vratiFakturuPoId(id))();
    }

}
